const translationConfig = {
  'default': {
    separator: '',
    abbr: {
      3: {
        generic: 'K',
        person: 'K'
      },
      6: {
        generic: 'M',
        person: 'M'
      },
      9: {
        generic: 'B',
        person: 'B'
      },
      12: {
        generic: 'T',
        person: 'T'
      }
    }
  },
  'ja-JP': {
    separator: '',
    abbr: {
      4: {
        generic: 'まん',
        person: 'まん'
      },
      8: {
        generic: 'おく',
        person: 'おく',
      },
      12: {
        generic: 'ちょう',
        person: 'ちょう'
      }
    }
  },
  'zh-CN': {
    separator: '',
    abbr: {
      4: {
        generic: 'まん',
        person: 'まん'
      },
      8: {
        generic: 'おく',
        person: 'おく',
      },
      12: {
        generic: 'ちょう',
        person: 'ちょう'
      }
    }
  },
  'zh-TW': {
    separator: '',
    abbr: {
      4: {
        generic: 'まん',
        person: 'まん'
      },
      8: {
        generic: 'おく',
        person: 'おく',
      },
      12: {
        generic: 'ちょう',
        person: 'ちょう'
      }
    }
  },
  // 'en-IN': {
  //   separator: ' ',
  //   abbr: {
  //     5: 'lakh',
  //     7: 'crore',
  //     12: 'lakh crore',
  //     14: 'crore crore',
  //   }
  // }
};

export {translationConfig};
